import React from 'react'

function InfoEvento() {
  return (
    <div className="page">
      <div className="text-page">
        <h1>Informazioni sull'Evento</h1>
        <p>Luogo: Piazza del Paese</p>
        <p>Data: 15 Agosto 2025</p>
        <p>Ingresso gratuito</p>
      </div>
    </div>
  )
}

export default InfoEvento
